import React, { useContext } from "react";
import { Link } from "react-router-dom";
import ic_upload from "../../../assets/images/ic_upload.svg";
import ic_upload_dark from "../../../assets/images/ic_upload_dark.svg";


import ic_green_pen from "../../../assets/images/ic_green_pen.svg";
import { AppContext } from "../../../context/AppContext";
const TemplateLogoTop = () => {
  const { Dark } = useContext(AppContext);

  return (
    <main id="main-TemplateLogoTop">
      <div id="main-default-edit-form">
        <div className="main-invoice-card">
          <div className="invoice-inner-main">
            {/* ========================================================== */}
            <div className="text-invoice-main">
              <div className="middle-top-logo text-center p-3">
                <div className="logo-top-left">
                  <div className="pt-4">
                    {Dark === "lightMode" ? (
                      <img src={ic_upload} alt="" />
                    ) : (
                      <img src={ic_upload_dark} alt="" />
                    )}{" "}
                    <div className="up-text">
                      <label htmlFor="">Upload your logo here</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-invoice-inner">
                <div className="left"></div>
                <div className="right">
                  <div className="invoice-text-right">
                    <div className="text-invoice-heading">
                      <label htmlFor="">Tax Invoice</label>
                    </div>
                    <div className="invoice-number">
                      <label htmlFor="" className="key">
                        Invoice No.
                      </label>
                      <label htmlFor="" className="value ms-4">
                        XXXXXX
                      </label>
                    </div>
                    <div className="date">
                      <div>
                        <label htmlFor="" className="key">
                          Date:{" "}
                        </label>
                      </div>

                      {/* <label htmlFor="date" className="value date-input">
                      <img src={ic_calender} alt="" />
                    </label> */}

                      <div className="d-flex ">
                        <input
                          type="date"
                          name=""
                          id="date"
                          className="cald form-control form-control-date"
                        />
                        <img
                          src={ic_green_pen}
                          alt=""
                          className="pen-img ms-2"
                          id="pen-img"
                        />
                      </div>
                    </div>
                    <div className="date" id="deu-date">
                      <div>
                        <label htmlFor="" className="key">
                          Due Date:{" "}
                        </label>
                      </div>

                      {/* <label htmlFor="date" className="value date-input">
                      <img src={ic_calender} alt="" />
                    </label> */}

                      <div className="d-flex ">
                        <input
                          type="date"
                          name=""
                          id="date"
                          className="cald form-control form-control-date"
                        />
                        <img
                          src={ic_green_pen}
                          alt=""
                          className="pen-img ms-2"
                          id="pen-img"
                        />
                      </div>
                    </div>
                    <div className="deu-date"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* ========================================================== */}
            <div className="name-details-main">
              <div className="name-details-inner ">
                <div className="left">
                  <div className="left-input-info">
                    <input
                      type="text"
                      className="form-control mb-1"
                      placeholder="Owner Name"
                      id="name"
                    />
                    <textarea
                      name=""
                      id="text-area"
                      cols="30"
                      rows="10"
                      className="form-control mb-1"
                      placeholder="Address"
                    ></textarea>
                    <div className="contact">
                      <label htmlFor="">Contact No. </label>
                      <input type="text" className="form-control mb-1" />
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">
                        GST No. <br /> <span>(Optional)</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="XX-XXXXXXXXXX-XXX"
                      />
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="XXXXXXXXXX"
                      />
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="place-text-right">
                    <div className="mb-4">
                      <label htmlFor="" className="key">
                        Place of Supply:
                      </label>
                      <div className="d-flex">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option selected>Open this select menu</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </select>
                        <img
                          src={ic_green_pen}
                          alt=""
                          className="pen-img ms-2"
                          id="pen-img"
                        />
                      </div>
                    </div>
                    <div className="">
                      <label htmlFor="" className="key">
                        Mode of Payment:
                      </label>
                      <div className="d-flex mb-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option selected>Open this select menu</option>
                          <option value="1">
                            <Link to="/">add</Link>
                          </option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </select>
                        <img
                          src={ic_green_pen}
                          alt=""
                          className="pen-img ms-2"
                          id="pen-img"
                        />
                      </div>
                    </div>
                    <div className="d-flex mb-1">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Cheque No. XXX06542"
                      />

                      <img
                        src={ic_green_pen}
                        alt=""
                        className="pen-img ms-2"
                        id="pen-img"
                      />
                    </div>
                    <div className="d-flex mb-1">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name of Bank"
                      />

                      <img
                        src={ic_green_pen}
                        alt=""
                        className="pen-img ms-2"
                        id="pen-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="name-details-main" id="info">
              <div className="name-details-inner">
                <div className=" left " id="left">
                  <div className="name">
                    <label htmlFor="" id="small-heading">
                      Bill To,
                    </label>
                  </div>
                  <div className="left-input-info">
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control mb-1 me-2"
                        placeholder="Name"
                      />{" "}
                      <Link to="#">
                        <img src={ic_green_pen} alt="" />
                      </Link>
                    </div>
                    <div className="d-flex">
                      <textarea
                        name=""
                        id="text-area"
                        cols="30"
                        rows="10"
                        className="form-control mb-1  me-2"
                        placeholder="Address"
                      ></textarea>
                      <Link to="#">
                        <img src={ic_green_pen} alt="" />
                      </Link>
                    </div>

                    <div className="contact">
                      <label htmlFor="">Contact No. </label>
                      <div className="d-flex">
                        <input type="text" className="form-control mb-1 me-2" />

                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">
                        GST No. <br /> <span>(Optional)</span>{" "}
                      </label>
                      <div className="d-flex">
                        {" "}
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="XX-XXXXXXXXXX-XXX"
                        />
                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">PAN No.</label>
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="XXXXXXXXXX"
                        />
                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" left " id="left">
                  <div className="name">
                    <label htmlFor="" id="small-heading">
                      Ship To,
                    </label>
                  </div>
                  <div className="left-input-info">
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control mb-1 me-2"
                        placeholder="Name"
                      />{" "}
                      <Link to="#">
                        <img src={ic_green_pen} alt="" />
                      </Link>
                    </div>
                    <div className="d-flex">
                      <textarea
                        name=""
                        id="text-area"
                        cols="30"
                        rows="10"
                        className="form-control mb-1  me-2"
                        placeholder="Address"
                      ></textarea>
                      <Link to="#">
                        <img src={ic_green_pen} alt="" />
                      </Link>
                    </div>

                    <div className="contact">
                      <label htmlFor="">Contact No. </label>
                      <div className="d-flex">
                        <input type="text" className="form-control mb-1 me-2" />

                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">
                        GST No. <br /> <span>(Optional)</span>{" "}
                      </label>
                      <div className="d-flex">
                        {" "}
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="XX-XXXXXXXXXX-XXX"
                        />
                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="contact mb-1">
                      <label htmlFor="">PAN No.</label>
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="XXXXXXXXXX"
                        />
                        <Link to="#">
                          <img src={ic_green_pen} alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-table-main">
              <table>
                <thead>
                  <tr className="heading-row">
                    <td>#</td>
                    <td>Product Name</td>
                    <td>HSN/SAC</td>
                    <td>Quantity</td>
                    <td>Rate</td>
                    <td colSpan="2">CGST</td>
                    <td colSpan="2">SGST</td>
                    <td>Amount</td>
                  </tr>
                </thead>
                <tbody className="greyTemplate">
                  <td>1</td>
                  <td>Enter Name Of Product</td>
                  <td>0.0</td>
                  <td>%0</td>
                  <td>₹0.0</td>
                  <td>0%</td>
                  <td>₹0.0</td>
                  <td>0%</td>
                  <td>₹0.0</td>
                  <td>₹0.0</td>
                </tbody>
              </table>

              <Link to="#" className="add-row-btn">
                Add row
              </Link>
            </div>
            <div className="sub-total-section">
              <div className="left">
                <div className="text-sub">
                  <label htmlFor="">Sub Total</label>
                </div>
                <div className="text-sub">
                  <label htmlFor="">CGST@0%</label>
                </div>
                <div className="text-sub">
                  <label htmlFor="">SGST@0%</label>
                </div>
              </div>
              <div className="right">
                <div className="sub-total">
                  <label htmlFor="">₹0.0</label>
                </div>
                <div className="sub-total">
                  <label htmlFor="">₹0.0</label>
                </div>
                <div className="sub-total">
                  <label htmlFor="">₹0.0</label>
                </div>
              </div>
            </div>
            <div className="mainsub-total"></div>
            <div className="total-amt-main">
              <div className="sub-total-section" id="sub-total-section">
                <div className="left">
                  <div className="text-sub">
                    <label htmlFor="">Total Amount</label>
                  </div>
                </div>
                <div className="right">
                  <div className="sub-total">
                    <label htmlFor="">₹0.0</label>
                  </div>
                </div>
              </div>
              <div className="in-word">
                <label htmlFor="">Amount In Words</label>
              </div>
            </div>
            <div className="line-total"></div>
            <div className="disc-sign-main row">
              <div className="col-lg-7 left ps-0">
                <div className="description">
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder="Declaration"
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-5 right pe-0">
                <div className="upload">
                  {Dark === "lightMode" ? (
                    <img src={ic_upload} alt="" />
                  ) : (
                    <img src={ic_upload_dark} alt="" />
                  )}{" "}
                  <br />
                  <label htmlFor="" className="text-up">
                    Upload your signature
                  </label>
                  <br />
                  <label htmlFor="" className="text-auth">
                    Authorized Signature
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TemplateLogoTop;
